import React from 'react'

const Avatar = ({ firstName, surname }) => {
  const initials = `${firstName?.[0] ?? ''}${surname?.[0] ?? ''}`.toUpperCase()
  return <div className="avatar">{initials}</div>
}

export default Avatar
